export const UPDATE_METHODOLOGY = 'MODULE_SELECTION/METHODOLOGY/UPDATE';
export const UPDATE_UNIVERSE = 'MODULE_SELECTION/UNIVERSE/UPDATE';
export const REMOVE_METHODOLOGY = 'MODULE_SELECTION/METHODOLOGY/REMOVE';
export const REMOVE_UNIVERSE = 'MODULE_SELECTION/UNIVERSE/REMOVE';
export const RESET_ALL = 'MODULE_SELECTION/ALL/RESET';
